import React, { Component } from 'react'
import { connect } from 'react-redux'
import { localize } from '@daptiv/localize'
import PropTypes from 'prop-types'

const localizeHOC = (WrappedComponent) => {
  class LocalizedComponent extends Component {
    constructor(props) {
      super(props)
      this.state = { localize: (key, ...args) => localize(props.resources || {}, key, ...args) }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.resources !== nextProps.resources) {
        // As the localize function is passed to the wrapped component via props,
        // Providing a new localize function only if the resources object changes can prevent unecessary Pure component updates
        this.setState({ localize: (key, ...args) => localize(nextProps.resources, key, ...args) })
      }
    }

    render() {
      let newProps = { ...this.props, localize: this.state.localize }
      return <WrappedComponent {...newProps} />
    }
  }

  LocalizedComponent.propTypes = {
    resources: PropTypes.object
  }

  const mapStateToProps = (state, ownProps) => ({ resources: state.resources })
  let ComponentToReturn = connect(mapStateToProps)(LocalizedComponent)
  ComponentToReturn.displayName = WrappedComponent.displayName || WrappedComponent.name  // Keep display name the same to reduce unit test friction after introducing this HOC
  ComponentToReturn.WrappedComponent = WrappedComponent
  return ComponentToReturn
}

export default localizeHOC



// WEBPACK FOOTER //
// ./src/higherOrderComponents/localize/localize.js